import { IonCardContent, IonContent, IonPage } from "@ionic/react";
import React from "react";
import Header from "../../../components/Header";

const HelpFaq: React.FC = () => {
    const handleBack = () => {
        window.history.back();
    };

    return (
        <IonPage>
            <Header
                showGreeting={false}
                showPageTitle={true}
                showUserIcon={false}
                pageTitle="Help & FAQ"
                showBackButton={true}
                onBackButtonClick={handleBack}
            />
            <IonContent className="ion-padding" style={{ "--background": "#F7F5FA" }}>
                <IonCardContent>
                    <div>
                        <h1 style={{ marginBottom: "0.5rem" }}>
                            Arc Connect Mobile App – Help & FAQ
                        </h1>
                        <section style={{ marginTop: "1.5rem" }}>
                            <h2 style={{ fontWeight: "bold" }}>Frequently Asked Questions</h2>
                            <ul>
                                <li>
                                    <strong>What is the Arc Connect app?</strong>
                                    <br />
                                    The Arc Connect app helps you track your respiratory therapy, connect with your BiWaze® system, and access educational resources.
                                </li>
                                <li style={{ marginTop: "1rem" }}>
                                    <strong>Who can use the app?</strong>
                                    <br />
                                    The app is intended for users 18 years or older. If you are under 18, a parent or guardian must supervise your use.
                                </li>
                                <li style={{ marginTop: "1rem" }}>
                                    <strong>Does the app provide medical advice?</strong>
                                    <br />
                                    No, the app is for educational and informational purposes only. Always consult your healthcare provider for medical advice.
                                </li>
                                <li style={{ marginTop: "1rem" }}>
                                    <strong>How is my data used?</strong>
                                    <br />
                                    Your data is stored securely and may be shared with authorized healthcare providers or partners as allowed by law. See our Privacy Policy for details.
                                </li>
                                <li style={{ marginTop: "1rem" }}>
                                    <strong>Can I delete my account or data?</strong>
                                    <br />
                                    Yes, you have rights to access, correct, or request deletion of your personal data. Contact us for assistance.
                                </li>
                                <li style={{ marginTop: "1rem" }}>
                                    <strong>What should I do in an emergency?</strong>
                                    <br />
                                    Do not use the app in an emergency. Call 911 or your local emergency number immediately.
                                </li>
                                <li style={{ marginTop: "1rem" }}>
                                    <strong>How do I get support?</strong>
                                    <br />
                                    See the contact information below to reach our support team.
                                </li>
                            </ul>
                        </section>

                        <section style={{ marginTop: "2rem" }}>
                            <h2 style={{ fontWeight: "bold" }}>Contact Support</h2>
                            <address>
                                <span className="text-grey font-semibold">ABM Respiratory Care</span>
                                <br />
                                860 Blue Gentian Road
                                <br />
                                Suite 200
                                <br />
                                Eagan, MN 55121
                                <br />
                                <span className="text-grey font-semibold">Email:</span>{" "}
                                <a href="mailto:Customer.Service@abmrc.com">
                                    Customer.Service@abmrc.com
                                </a>
                                <br />
                                <span className="text-grey font-semibold">Phone:</span>{" "}
                                <a href="tel:1-877-226-7201">1-877-226-7201</a>
                            </address>
                        </section>
                    </div>
                </IonCardContent>
            </IonContent>
        </IonPage>
    );
};

export default HelpFaq;
